import { jsx as a } from "react/jsx-runtime";
import { createContext as k, forwardRef as c, useMemo as b, useContext as x } from "react";
import * as u from "@radix-ui/react-radio-group";
import { twMerge as l } from "tailwind-merge";
const s = k({
  size: "md",
  variant: "none"
}), f = c(
  ({ size: t = "md", variant: e = "none", className: o, children: r, ...d }, m) => {
    const p = b(
      () => ({
        size: t,
        variant: e
      }),
      [t, e]
    );
    return /* @__PURE__ */ a(s.Provider, { value: p, children: /* @__PURE__ */ a(
      u.Root,
      {
        ref: m,
        className: l(
          (e === "none" || e === "card") && "flex flex-col gap-y-2",
          e === "toggle" && "flex flex-wrap items-stretch rounded-xl bg-gray-100 p-1",
          e === "card" && "sm:flex-row sm:gap-x-2 sm:gap-y-0",
          o
        ),
        ...d,
        children: r
      }
    ) });
  }
);
f.displayName = "RadioGroup";
const h = c(({ id: t, value: e, className: o, children: r, size: d, variant: m, ...p }, R) => {
  const g = x(s), n = d ?? g.size, i = m ?? g.variant, G = b(
    () => ({
      size: n,
      variant: i
    }),
    [n, i]
  );
  return /* @__PURE__ */ a(s.Provider, { value: G, children: /* @__PURE__ */ a(
    u.Item,
    {
      ...p,
      ref: R,
      id: t ?? (e === "" ? void 0 : e),
      value: e,
      className: l(
        "group cursor-pointer",
        "radix-disabled:cursor-not-allowed radix-disabled:opacity-50 radix-disabled:text-gray-400",
        i === "none" && [
          "flex flex-shrink-0 items-center justify-center",
          "rounded-full border border-gray-300 bg-white",
          "radix-state-checked:border-blue-500 radix-state-checked:bg-blue-500",
          n === "sm" && "h-3 w-3",
          n === "md" && "h-4 w-4",
          n === "lg" && "h-5 w-5"
        ],
        i === "card" && [
          "relative w-full text-left",
          "rounded-md border border-gray-300 bg-white p-4",
          "radix-state-checked:border-blue-500"
        ],
        i === "toggle" && [
          "flex items-center justify-center whitespace-normal text-center",
          "h-auto min-h-10 flex-1 rounded-lg bg-transparent px-4 py-2",
          "text-base font-medium text-gray-600",
          "radix-state-checked:bg-white radix-state-checked:text-black radix-state-checked:drop-shadow-sm"
        ],
        i === "custom" && null,
        o
      ),
      children: r || /* @__PURE__ */ a(u.Indicator, {})
    }
  ) });
});
h.displayName = "RadioGroupItem";
const w = c(
  ({ className: t, children: e, ...o }, r) => /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex items-start gap-2", "group-radix-disabled:opacity-50", t),
      ...o,
      children: e
    }
  )
);
w.displayName = "RadioGroupItemContainer";
const y = c(
  ({ className: t, children: e, ...o }, r) => {
    const { size: d } = x(s);
    return /* @__PURE__ */ a(
      "div",
      {
        ref: r,
        className: l(
          "mt-1.5 flex items-center justify-center rounded-full",
          "border border-gray-300",
          "group-radix-state-checked:bg-blue-500 group-radix-state-checked:border-blue-500",
          "group-radix-disabled:cursor-not-allowed group-radix-disabled:opacity-50",
          d === "sm" && "h-3 w-3",
          d === "md" && "h-4 w-4",
          d === "lg" && "h-5 w-5",
          t
        ),
        ...o,
        children: e
      }
    );
  }
);
y.displayName = "RadioGroupIndicatorContainer";
const I = c(
  ({ className: t, ...e }, o) => {
    const { size: r } = x(s);
    return /* @__PURE__ */ a(
      u.Indicator,
      {
        ref: o,
        className: l(
          "flex items-center justify-center",
          "rounded-full bg-white",
          "radix-disabled:bg-gray-400",
          r === "sm" && "h-1 w-1",
          r === "md" && "h-1.5 w-1.5",
          r === "lg" && "h-2 w-2",
          t
        ),
        ...e
      }
    );
  }
);
I.displayName = "RadioGroupIndicator";
const v = f, z = h, P = w, V = I, M = y;
export {
  V as Indicator,
  M as IndicatorContainer,
  z as Item,
  P as ItemContainer,
  f as RadioGroup,
  I as RadioGroupIndicator,
  y as RadioGroupIndicatorContainer,
  h as RadioGroupItem,
  w as RadioGroupItemContainer,
  v as Root
};
